import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "signage__container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SignageLayouts = _resolveComponent("SignageLayouts", true)!
  const _component_TierLimit = _resolveComponent("TierLimit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SignageLayouts),
    _createVNode(_component_TierLimit, {
      modelValue: _ctx.showTierCallout,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showTierCallout) = $event)),
      isCallout: false,
      isLimit: false,
      message: "Upgrade your Ditto account to unlock signage."
    }, null, 8, ["modelValue"])
  ]))
}